import { Container, IndividualOption, Option, Select } from './styles';
import { YesNoVariantProps } from './types';

const YesNoVariant: React.FC<YesNoVariantProps> = ({
  yesOptionValue,
  noOptionValue,
  fetchedTags,
  handleSetYesOptionValue,
  handleSetNoOptionValue,
}) => {
  const handleYesChange = (event) => {
    const value = event.target.value;

    if (value === 'yes-answer') {
      handleSetYesOptionValue(null);
    } else {
      handleSetYesOptionValue(value);
    }
  };

  const handleNoChange = (event) => {
    const value = event.target.value;

    if (value === 'yes-answer') {
      handleSetNoOptionValue(null);
    } else {
      handleSetNoOptionValue(value);
    }
  };

  return (
    <Container>
      <IndividualOption>
        If candidate responds &quot;Yes&quot;:
        <Select onChange={handleYesChange} value={yesOptionValue ? yesOptionValue : 'yes-answer'}>
          <Option value={'yes-answer'}>Select a tag</Option>
          {fetchedTags.map((fetchedTag) => {
            return (
              <Option value={fetchedTag.id} key={fetchedTag.id}>
                {fetchedTag.label}
              </Option>
            );
          })}
        </Select>
      </IndividualOption>

      <IndividualOption>
        If candidate responds &quot;No&quot;:
        <Select onChange={handleNoChange} value={noOptionValue ? noOptionValue : 'no-answer'}>
          <Option value="no-answer">Select a tag</Option>
          {fetchedTags.map((fetchedTag) => (
            <Option value={fetchedTag.id} key={fetchedTag.label}>
              {fetchedTag.label}
            </Option>
          ))}
        </Select>
      </IndividualOption>
    </Container>
  );
};

export default YesNoVariant;
